export enum LastDiscoveryType {
    Unknown,
    Warning,
    Error,
    OK,
}
